import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateLoader } from '../../../_redux/LoaderSlice';
import { updateSnackbar } from '../../../_redux/SnackbarSlice';
import { getApi, sessionExpired } from '../../../_redux/_apiHelpers/_apihelper';
import GetJobId from '../../../_utilities/GetJobId';
import CustomerComponent from '../CustomerComponent';

import { GetUserId, GetUserInfo } from '../../../_utilities/getUserInfo';
const CustomerView = () => {
  const [showTable, setShowTable] = useState(false);
  let getJobCode = GetJobId();
  const initialSnackbar = { type: '', message: '' };

  const dispatch = useDispatch();
  const [getDetails, setGetDetails] = useState(initialDetails);

  const actionBtns = [
    {
      variant: 'contained',
      label: 'Edit',
      type: 'back',
      style: {
        backgroundColor: 'var(--primary-bg-color)',
        color: 'var(--primary-background-text-color)',
        borderRadius: '25px',
        width: '6rem',
        textTransform: 'capitalize',
      },
      class: 'buttonHover',
      navigateTo: `/admin/layout/customer/edit/${getJobCode}`,
    },
  ];

  useEffect(() => {
    async function init() {
      const getUserId = await GetUserId();
      getData(getUserId);
    }
    init();
  }, []);

  const onGetValidData = (data) => {
    console.log(data);
  };
  const getData = async (id) => {
    try {
      setShowTable(false);
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));
      const res = await getApi(
        `/mgmt/customer/${id}?isBillingInfo=true&atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      const jsonData = res.data;
      if (jsonData.code === 200) {
        dispatch(updateLoader(false));
        const myData = jsonData.customer;
        let country = JSON.parse(myData[0].country);
        myData[0]['country'] = country.map((x) => x.id.toString());
        myData[0]['client_id'] = myData[0].id;
        // Normalize primary_billing_country to a readable string (country name)
        const normalizePrimaryBillingCountry = (value) => {
          if (!value) return '';
          // If it's already an object with name
          if (typeof value === 'object' && !Array.isArray(value)) {
            return value.name || value.countryName || '';
          }
          // If it's an array, take first element's name
          if (Array.isArray(value)) {
            const first = value[0] || {};
            return first.name || first.countryName || first.label || '';
          }
          // If it's a plain string, try JSON.parse first; otherwise return as-is
          if (typeof value === 'string') {
            try {
              const parsed = JSON.parse(value);
              return normalizePrimaryBillingCountry(parsed);
            } catch {
              return value;
            }
          }
          return '';
        };

        myData[0]['primary_billing_country'] = normalizePrimaryBillingCountry(
          myData[0].primary_billing_country
        );
        let lisofDomains = []; //myData.map(x => x.employeeportal_domains !== "null");
        myData.forEach((list) => {
          if (
            list.employeeportal_domains &&
            list.employeeportal_domains !== 'null'
          ) {
            lisofDomains.push(list.employeeportal_domains);
          }
        });
        myData[0].employeeportal_domains = lisofDomains;
        setGetDetails(myData[0]);
        let portal = JSON.parse(myData[0].portal);
        myData[0]['portal'] = portal.map((x) => x.id.toString());
        setGetDetails(myData[0]);
        setShowTable(true);
        dispatch(updateSnackbar({ type: 'success', message: '' }));
      } else {
        setShowTable(true);
        dispatch(updateLoader(false));
        dispatch(updateSnackbar({ type: 'error', message: '' }));
      }
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      dispatch(updateLoader(false));
    }
  };

  useEffect(() => {
    console.log('getDetails', getDetails);
    console.log('showTable', showTable);
  }, [getDetails]);

  return (
    <React.Fragment>
      <div id="CustomerView">
        {getDetails.client_id && (
          <CustomerComponent
            componentType="view"
            input={getDetails}
            iniValue={getDetails}
            actions={actionBtns}
            onValidData={onGetValidData}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default CustomerView;

const initialDetails = {
  companyName: '',
  registerdAddress: '',
  website: '',
  contactDetails: '',
  contactcontactPersonName: '',
  country: [],
  onBoardingDate: '',
  portal: [],
  employeeportal_domains: '',
  clientStatus: '',
  segment: 0,
  // Billing-related defaults
  customer_legal_name: '',
  customer_billing_email: '',
  customer_billing_phone: '',
  max_number_of_users: '',
  min_number_of_users: '',
  charge_per_ats_user: '',
  bill_date: '',
  payment_cycle: '',
  contract_start_date: '',
  contract_end_date: '',
  active_users: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  zipcode: '',
  primary_billing_country: [],
};
